import moment from 'moment';
import React from 'react';
import './SignatureElement.scss';

const ReviewElement = (props) => {
  return (
    <div className="signature-element reviewed">
      <div className="signed">
        <div className="signed-text">Approved</div>
      </div>
      <div>
        <b>{props.approvedTwoBy}</b> {moment(props.approvedTwoAt).format('HH:mm on MMM D, YYYY')}
        {props.approveCommentTwo && <div><b>Notes:</b> {props.approveCommentTwo}</div>}
      </div>
    </div>
  );
};

export default ReviewElement;
